import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  makeStyles,
} from "@material-ui/core";
import React from "react";

import "../styles/custom-select.css";
import { DownArrow } from "../shared-resources/SVGIcons";

function CustomSelect(props) {
  const {
    id,
    labelVal,
    items,
    onChangeItem,
    selectedValue,
    width = "100%",
    errorValue = false,
  } = props;
  const useStyles = makeStyles((theme) => ({
    root: {
      width: width,
      background: "#fff",
      border: errorValue ? "1px solid red" : "1px solid #ececec",
      borderRadius: theme.spacing(0.75),
    },
    menuItem: {
      fontSize: "13px",
      padding: "2px 8px",
    },
  }));
  const classes = useStyles();
  return (
    <div className="customSelect">
      <FormControl className={classes.root} variant="outlined">
        <InputLabel>{labelVal}</InputLabel>
        <Select
          id={id}
          name={id}
          onChange={onChangeItem}
          label={labelVal}
          value={selectedValue}
          IconComponent={() => <DownArrow />}
        >
          {items.map((item, i) => (
            <MenuItem
              className={classes.menuItem}
              key={i}
              value={item.id}
              name={item.text}
            >
              {item.text}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}

export default CustomSelect;
